module.exports = __webpack_public_path__ + "img/Copy.319e0013.svg";